export const USER_FRIEND_LIST_URL: string = '/v2/profiles/me/friends';
export const USER_FRIEND_PROFILE_URL: string = '/v2/profiles';
export const USER_PROFILE_STAT_TEMPLATE: string = '/v1/profiles/{userId}/stats';
export const USER_DETAIL_INFO_URL: string = '/v3/users/me';
export const IP_LOCATION_URL = '/v2/profiles/me/iplocation';

export enum USER_FRIEND_STATUS {
    FRIEND = 'Friends',
    PENDING_SENT_INVITE = 'PendingSentInvite',
}
